export const COOKIE_KEY_PLAY_OVERLAY_KUP = 'kubaparis_overlay';

export const landingPagePostFetchLimit = 24;
